// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-dashboard {
  padding: 20px;
  min-height: 100vh;
  font-family: Arial, sans-serif;
}

.project-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.project-header h2 {
  font-size: 24px;
  font-weight: bold;
}

.add-project-button {
  background-color: #79c42b;
  font-size: medium;
  font-weight: bold;
  color: white;
  padding: 8px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

.add-project-button:hover {
  background-color: #68a822; /* slightly darker for hover */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.add-project-button:active {
  transform: scale(0.98);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.add-project-button:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

/* For the update icon, you can add a hover effect if needed */
.pj-update-icon {
  font-size: xx-large;
  color: #004dc6;
  transition: transform 0.1s ease;
  cursor: pointer;
}

.pj-update-icon:hover {
  transform: scale(1.05);
}

.pj-update-icon:active {
  transform: scale(0.95);
}

.pj-update-icon:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.project-tabs {
  display: flex;
  gap: 25px;
  margin-top: 15px;
  color: #777;
  font-weight: bold;
}

.project-tabs span {
  cursor: pointer;
}

.active-tab {
  color: #004dc6;
  border-bottom: 2px solid #004dc6;
}

.project-cards-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 20px;
}

.add-project-card {
  background-color: white;
  border-radius: 10px;
  padding: 0% 5%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
}

.company {
  display: flex;
  justify-content: space-between;
  margin: 2% 0 0 0;
}

.company h3 {
  width: 70%;
  margin: 2% 0 5% 0;
}

.project-label {
  color: #888;
  margin: 0 0 1% 0;
  font-size: medium;
}

.project-value {
  font-size: medium;
  font-weight: bold;
  margin: 0 0 6% 0;
}

.pj-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.pj-modal-content {
  background-color: #e8e9ea;
  padding: 0;
  width: 90%;
  position: relative;
}

.pj-close-button {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 20px;
  cursor: pointer;
}

/* Container for the entire set of controls in the General Templates tab */
.template-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 1rem;
}

/* Style for the dropdown label */
.template-controls label {
  font-weight: bold;
  margin-right: 0.5rem;
}

/* Style for the dropdown select element */
.template-controls select {
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
}

.template-controls .download-form-button,
.template-controls .view-template-button,
.template-controls .download-template-button {
  display: flex;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.2s ease-in-out;
  align-items: center;
}

/* Specific style for the View Template button */
.template-controls .view-template-button {
  background-color: #b2b3b3;
  border: 1px solid #848585;
  color: #fff;
}

.template-controls .view-template-button:hover {
  background-color: #a8a9a9;
}

.template-controls .download-form-button,
.template-controls .download-template-button {
  background-color: #b2b3b3;
  border: 1px solid #848585;
  color: #fff;
}

.template-controls .download-form-button:hover,
.template-controls .download-template-button:hover {
  background-color: #a8a9a9;
}

.template-icons {
  font-size: 20px;
  margin: 0 0 0 5%;
}

/* Responsive Design */
@media (max-width: 768px) {
  .project-dashboard {
    padding: 30px;
  }
  .project-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .project-header h2 {
    font-size: 40px;
    margin-bottom: 10px;
  }

  .add-project-button {
    width: 100%;
    text-align: center;
  }

  .project-tabs {
    gap: 10px;
    flex-wrap: wrap;
    font-size: 14px;
  }

  .project-cards-container {
    grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
  }

  .add-project-card {
    padding: 5%;
  }
}

@media (max-width: 480px) {
  .project-header h2 {
    font-size: 18px;
  }

  .project-tabs {
    font-size: 12px;
    gap: 8px;
  }

  .project-cards-container {
    grid-template-columns: 1fr;
  }

  .pj-modal-content {
    width: 95%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UpdateProjects/ProjectsDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf;wBACsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,cAAc;EACd,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,0DAA0D;EAC5D;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".project-dashboard {\n  padding: 20px;\n  min-height: 100vh;\n  font-family: Arial, sans-serif;\n}\n\n.project-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.project-header h2 {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.add-project-button {\n  background-color: #79c42b;\n  font-size: medium;\n  font-weight: bold;\n  color: white;\n  padding: 8px 15px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n.add-project-button:hover {\n  background-color: #68a822; /* slightly darker for hover */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.add-project-button:active {\n  transform: scale(0.98);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.add-project-button:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n/* For the update icon, you can add a hover effect if needed */\n.pj-update-icon {\n  font-size: xx-large;\n  color: #004dc6;\n  transition: transform 0.1s ease;\n  cursor: pointer;\n}\n\n.pj-update-icon:hover {\n  transform: scale(1.05);\n}\n\n.pj-update-icon:active {\n  transform: scale(0.95);\n}\n\n.pj-update-icon:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.project-tabs {\n  display: flex;\n  gap: 25px;\n  margin-top: 15px;\n  color: #777;\n  font-weight: bold;\n}\n\n.project-tabs span {\n  cursor: pointer;\n}\n\n.active-tab {\n  color: #004dc6;\n  border-bottom: 2px solid #004dc6;\n}\n\n.project-cards-container {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.add-project-card {\n  background-color: white;\n  border-radius: 10px;\n  padding: 0% 5%;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.company {\n  display: flex;\n  justify-content: space-between;\n  margin: 2% 0 0 0;\n}\n\n.company h3 {\n  width: 70%;\n  margin: 2% 0 5% 0;\n}\n\n.project-label {\n  color: #888;\n  margin: 0 0 1% 0;\n  font-size: medium;\n}\n\n.project-value {\n  font-size: medium;\n  font-weight: bold;\n  margin: 0 0 6% 0;\n}\n\n.pj-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.pj-modal-content {\n  background-color: #e8e9ea;\n  padding: 0;\n  width: 90%;\n  position: relative;\n}\n\n.pj-close-button {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n/* Container for the entire set of controls in the General Templates tab */\n.template-controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 1rem;\n  padding: 2rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n/* Style for the dropdown label */\n.template-controls label {\n  font-weight: bold;\n  margin-right: 0.5rem;\n}\n\n/* Style for the dropdown select element */\n.template-controls select {\n  padding: 0.5rem;\n  font-size: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #fff;\n}\n\n.template-controls .download-form-button,\n.template-controls .view-template-button,\n.template-controls .download-template-button {\n  display: flex;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background-color 0.2s ease-in-out;\n  align-items: center;\n}\n\n/* Specific style for the View Template button */\n.template-controls .view-template-button {\n  background-color: #b2b3b3;\n  border: 1px solid #848585;\n  color: #fff;\n}\n\n.template-controls .view-template-button:hover {\n  background-color: #a8a9a9;\n}\n\n.template-controls .download-form-button,\n.template-controls .download-template-button {\n  background-color: #b2b3b3;\n  border: 1px solid #848585;\n  color: #fff;\n}\n\n.template-controls .download-form-button:hover,\n.template-controls .download-template-button:hover {\n  background-color: #a8a9a9;\n}\n\n.template-icons {\n  font-size: 20px;\n  margin: 0 0 0 5%;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .project-dashboard {\n    padding: 30px;\n  }\n  .project-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .project-header h2 {\n    font-size: 40px;\n    margin-bottom: 10px;\n  }\n\n  .add-project-button {\n    width: 100%;\n    text-align: center;\n  }\n\n  .project-tabs {\n    gap: 10px;\n    flex-wrap: wrap;\n    font-size: 14px;\n  }\n\n  .project-cards-container {\n    grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));\n  }\n\n  .add-project-card {\n    padding: 5%;\n  }\n}\n\n@media (max-width: 480px) {\n  .project-header h2 {\n    font-size: 18px;\n  }\n\n  .project-tabs {\n    font-size: 12px;\n    gap: 8px;\n  }\n\n  .project-cards-container {\n    grid-template-columns: 1fr;\n  }\n\n  .pj-modal-content {\n    width: 95%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
